import axios from "axios";
import { API_URL } from "./index";
import log from "loglevel";

class TemplatesService {
    getAll = () => {
        const url = API_URL.instructionPreset();
        return axios.get(url).catch((err) => log.debug(err));
    };
    create = (template) => {
        const url = API_URL.instructionPreset();
        return axios.post(url, template).then(response => response.data);
    };
    edit = (template) => {
        const url = API_URL.instructionPreset();
        return axios.put(url, template).then(response => response.data);
    };
    delete = (template) => {
        const url = API_URL.instructionPreset();
        return axios.delete(url + "/" + template).then(response => response.data);
    };
    filter = (params) => {
        const url = API_URL.instructionPreset("filter");
        return axios.get(url, { params }).catch((err) => log.debug(err));
    };
}

export default new TemplatesService();
